import { useState, useEffect, useRef } from 'react';
import '../css/stopWatch.less';
import { Row, Col } from 'antd';

const StopWatch = ({
  timerOn,
  isCountdown = false,
  initialMinutes = 30,
  onTimeUp,
  showWarning = true
}) => {
  const [time, setTime] = useState(
    isCountdown ? initialMinutes * 60 * 1000 : 0
  );

  const intervalRef = useRef(null);
  const endTimeRef = useRef(0);

  useEffect(() => {
    if (timerOn) {
      endTimeRef.current = Date.now() + time;

      intervalRef.current = setInterval(() => {
        const remainingTime = endTimeRef.current - Date.now();

        if (remainingTime <= 0) {
          clearInterval(intervalRef.current);
          setTime(0);
          if (onTimeUp) onTimeUp();
        } else {
          setTime(remainingTime);
        }
      }, 1000);
    } else {
      clearInterval(intervalRef.current);
    }
    return () => clearInterval(intervalRef.current);
  }, [timerOn]);


  const minutes = Math.floor((time / 60000) % 60);
  const seconds = Math.floor((time / 1000) % 60);

  const isWarning = isCountdown && minutes < 2 && showWarning;

  return (
    <Row className="stop-watch-container" justify="center">
      <Col className={`stop-watch ${isWarning ? 'warning' : ''}`}>
        <span className="counter">
          Tiempo restante: {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
        </span>
      </Col>
    </Row>
  );
};

export default StopWatch;
